
import MessageClient from "./MessageClient";
import { Constants } from "../../constants/constants";
import { IMultiLanguageContent, IRecordTemplateKeyword } from "../../commons/interfaces";


const TemplateCaseKeywordService = {

    getByTargetId: async (id: string): Promise<IRecordTemplateKeyword[]> => {
        const result = await MessageClient().get(`${Constants.ApiPath.TEMPLATE_CASE_KEYWORD.GET_BY_TARGET_ID}/${id}`);
        return result.data.result;
    },

    delete: async (id: string) => {
        const result = await MessageClient().delete(`${Constants.ApiPath.TEMPLATE_CASE_KEYWORD.DELETE}/${id}`);
        return result.data.result;
    },

    create: async (data: {
        keyword: string;
        targetId: string;
        value: IMultiLanguageContent;
    }) => {
        const result = await MessageClient().post(Constants.ApiPath.TEMPLATE_CASE_KEYWORD.CREATE, data);
        return result.data.result;
    },

    update: async (data: {
        id: string;
        keyword: string;
        targetId: string;
        value: IMultiLanguageContent;
    }) => {
        const result = await MessageClient().post(Constants.ApiPath.TEMPLATE_CASE_KEYWORD.UPDATE, data);
        return result.data.result;
    },

}

export default TemplateCaseKeywordService;
